import $ from 'jquery'

// Handles hiding and revealing of elements under search
// Accepts an array of wrapper selectors in ascending order
//
// During hiding wrappers indicated by selectors will be
// hidden if they contain no matching search elements or
// shown if they contain at least one
//
// During reveal wrappers will be revealed
class PartnerTemplateFilter {
  constructor(wrapperSelectors) {
    this.wrapperSelectors = wrapperSelectors
    this.wrapperMultiSelect = wrapperSelectors.join(', ')

    this.doNotSearch = '.empty'
  }

  reveal(selector) {
    $(selector).parents(this.wrapperMultiSelect).removeClass('sf-hidden')
    $(selector).removeClass('sf-hidden')
    $(this.doNotSearch)
      .parents(this.wrapperMultiSelect)
      .removeClass('sf-hidden')
  }

  // This can be optimized by maintaining an index
  // However, for elements numbering below 10000
  // Code simplicity beats optimization
  hide(selector, pattern) {
    $(this.doNotSearch).parents(this.wrapperMultiSelect).addClass('sf-hidden')

    const allElements = $(selector)
    const allParents = allElements.parents(this.wrapperMultiSelect)

    // Find matching elements
    const matchElements = $(selector).filter(function () {
      return $(this).text().toLowerCase().indexOf(pattern) > -1
    })
    const matchParents = matchElements.parents(this.wrapperMultiSelect)

    allParents.not(matchParents).addClass('sf-hidden')
    allElements.not(matchElements).addClass('sf-hidden')

    matchParents.removeClass('sf-hidden')
    matchElements.removeClass('sf-hidden')
  }
}

$(function () {
  $(document).on(
    'keyup change',
    '[data-behaviour~="partner-template-filter"]',
    function (event) {
      const query = $(this).val().toLowerCase()
      const itemSelector = $(this).data('filter-items')
      const parentSelectors = $(this).data('filter-parents')

      const hider = new PartnerTemplateFilter(parentSelectors)

      if (query === '' || event.keyCode === 27) {
        hider.reveal(itemSelector)
        $(this).val('')
      } else {
        hider.hide(itemSelector, query)
      }
    }
  )

  $(document)
    .find('[data-behaviour~="partner-template-filter"]')
    .trigger('keyup')
})
